import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { createPortal } from 'react-dom'
import Icon from '../../../../components/icons'
import EditKPIUNITModal from './editKPIUnit.modal'

interface Props {
    literal: string
    KPI: any
    onUpdate: () => void
}

const EditKPIUnitButton: React.FC<Props> = ({ literal, KPI, onUpdate }) => {
    const { t } = useTranslation()
    const [edit, setEdit] = useState<boolean>(false)
    const withoutUnitKpis: string[] = ['Conversion', 'Incremental Conversion', 'Total Distribution']
    const disabled: boolean = withoutUnitKpis.includes(KPI?.label || '')

    const handleUpdate = () => {
        onUpdate()
    }

    return (
        <>
            <button
                type="button"
                onClick={() => {
                    setEdit(true)
                }}
                aria-label={t('Edit KPI Unit')}
                className={`absolute w-[1.083rem] h-[1.083rem] bg-black rounded-full flex items-center justify-center top-2 right-2 ${disabled ? 'opacity-50 cursor-not-allowed' : ''}`}
                disabled={disabled}
            >
                <Icon name="edit" className="text-white" size={0.5} />
            </button>

            {edit && createPortal(<EditKPIUNITModal onUpdate={handleUpdate} literal={literal} KPI={KPI} isModalOpen={edit} onClose={() => setEdit(false)} />, document.body)}
        </>
    )
}

export default EditKPIUnitButton
